import type { GroupedCodingResult, SentimentCode } from 'src/types/dashboard';

const removeNullValuesFromArray = <T>(array: (T | null)[]): T[] =>
  array.filter((value) => value !== null) as T[];

const getTopicIdList = (
  treeData: GroupedCodingResult,
  topicSentimentId: string | null,
  sentiment?: SentimentCode,
): Array<string> => {
  if (sentiment === undefined && treeData.subTopics === undefined) {
    // On click of label of a topic
    return removeNullValuesFromArray([
      treeData.negativeId,
      treeData.neutralId,
      treeData.positiveId,
    ]);
  }

  if (sentiment === undefined && treeData.subTopics) {
    // On click of label of a category
    return removeNullValuesFromArray(
      treeData.subTopics.flatMap((topic) => [
        topic.neutralId,
        topic.positiveId,
        topic.negativeId,
      ]),
    );
  }

  if (sentiment !== undefined && treeData.subTopics !== undefined) {
    // On click of sentiment bar of a category
    return removeNullValuesFromArray(
      treeData.subTopics.map((topic) => {
        switch (sentiment) {
          case -1:
            return topic.negativeId;
          case 0:
            return topic.neutralId;
          case 1:
            return topic.positiveId;
          default:
            return null;
        }
      }),
    );
  }

  // On a click of sentiment bar of a topic
  return removeNullValuesFromArray([topicSentimentId]);
};

export default getTopicIdList;
